/*
 * @Descripttion: 
 * @version: 
 * @Author: yuhongyou
 * @Date: 2021-11-15 16:30:08
 * @LastEditors: YOYO [792611446@qq.com]
 * @LastEditTime: 2023-05-29 13:24:50
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    menuIsCollapse: false,
    pathName: "",
    currDbSource: {},
    currJobData: {},
    DbSource: [],
    screen: 0,
    mapData: {},
    alarm: {},
    orgBreadStr: '',
    systemName: '',
    menuName:'',
    menuNameNew:'',
    isOnline: false,
    isAlarmShow: true,
    alarmList: []
  },
  mutations: {
    // 是否报警
    setIsOnline(state, data) {
      state.isOnline = data
    },
    // 报警列表
    setAlarmList(state, data) {
      state.alarmList = data
    },
    changeMenuCollapse(state, data) {
      state.menuIsCollapse = data
    },
    changeOrgBread(state, data) {
      state.orgBreadStr = data
    },
    // 保存当前菜单栏的路径
    savePath(state, pathName) {
      state.pathName = pathName;
    },
    // 保存当前点击的数据源
    saveCurrDbSource(state, currDbSource) {
      state.currDbSource = currDbSource;
    },
    // 保存当前点击的元数据
    saveCurrJobData(state, currJobData) {
      state.currJobData = currJobData;
    },
    // 保存所有数据源
    saveDbSource(state, DbSource) {
      state.DbSource = DbSource;
    },
    setScreen(state, data) {
      state.screen = data
    },
    setMapData(state, data) {
      state.mapData = data
    },
    setAlarm(state, data) {
      state.alarm = data
    },
    systemName(state, data) {
      // console.log(data);
      state.systemName = data
    },
    menuName(state, data) {
      // console.log(data);
      state.menuName = data
    },
    menuNameNew(state, data) {
      // console.log(data);
      state.menuNameNew = data
    }
  },
  actions: {
    screenChange({
      commit,
      state
    }, data) {
      commit('setScreen', data);
    },
    mapDataChange({
      commit,
      state
    }, data) {
      commit('setMapData', data);
    },
    alarmData({
      commit,
      state
    }, data) {
      commit('setAlarm', data);
    },
    setSystemName({
      commit,
      state
    }, name) {
      // console.log(name);
      commit('systemName', name)
    },
    setMenuName({
      commit,
      state
    }, name) {
      // console.log(name);
      commit('menuName', name)
    },
    setMenuNameNew({
      commit,
      state
    }, name) {
      // console.log(name);
      commit('menuNameNew', name)
    }
  }
})